<template>
  <Stack
    gap="4"
  >
    <LoaderWithText v-if="chatStore.isFetchingConversations">
      Fetching conversations…
    </LoaderWithText>

    <template
      v-else
    >
      <Button
        variant="ask-anything"
        icon-before="fas fa-comments"
        size="3_5"
        :to="{ name: 'ask-anything' }"
      >
        New conversation
      </Button>

      <Stack gap="2">
        <Label size="3">Previous conversations</Label>

        <MenuList
          v-if="topConversations.length"
          class="message-list"
        >
          <router-link
            v-for="conversation in topConversations"
            :key="conversation.id"
            class="stk-menu-item message-item"
            :class="{ 'is-active': conversation.id === chatStore.currentConversationId }"
            :to="{ name: 'ask-anything', params: { conversationId: conversation.id } }"
            :title="conversation.updated_at ? relativeDate(conversation.updated_at) : ''"
          >
            <Stack
              gap="0"
              class="message-content"
            >
              <p class="message-title">
                {{ conversation.title || 'New conversation' }}
              </p>
            </Stack>
          </router-link>
        </MenuList>

        <div v-else>
          No previous conversations.
        </div>
      </Stack>
    </template>
  </Stack>
</template>

<script setup>
import { computed } from 'vue';
import { Label, LoaderWithText, Button, MenuList, Stack } from '@stakeui';
import { relativeDate } from '@frontend/shared/Util.js';
import { useChatStore } from '@frontend/ui/stores/chatStore';

const chatStore = useChatStore();

const topConversations = computed(() => {
  const conversationsWithMessages = chatStore.latestConversations.filter(conv => conv.messages.length > 1);
  return conversationsWithMessages.slice(0, 10);
});
</script>

<style scoped>
.message-list,
.message-item,
.message-item > :deep(span),
.message-content {
  display: flex;
  overflow: hidden;
}

.message-list {
  gap: 0;
  margin: 0 -0.625em;
  font-size: 0.875em;
}

.message-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.message-item {
  --hover-bg: hsl(var(--stk-ai-pink-h) var(--stk-ai-pink-s) 98%);
  --hover-fg: hsl(var(--stk-ai-pink-h) var(--stk-ai-pink-s) 30%);

  &.is-active {
    --icon-color: hsl(var(--stk-ai-pink-h) var(--stk-ai-pink-s) 50%);
    background-color: hsl(var(--stk-ai-pink-h) var(--stk-ai-pink-s) 90%);
    color: hsl(var(--stk-ai-pink-h) var(--stk-ai-pink-s) 30%);
  }
}
</style>
